export default "__VITE_ASSET__Dcf1$Ku___"